// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QVIH","toggle":"styles_toggle__531Qp","preview":"styles_preview__1CQLo"};